import type { EatonDuplicateRow, EatonPriceRow } from './types';

function normalizePrice(value: string): string {
  return value.replace(/[$,\s]/g, '');
}

/**
 * Catalogues that land on more than one SPA, or that show more than one
 * net price — the review step Courtney does after pasting tabs together.
 */
export function findDuplicateCatalogs(
  prices: readonly EatonPriceRow[],
): EatonDuplicateRow[] {
  const byCatalog = new Map<string, EatonPriceRow[]>();
  for (const price of prices) {
    const current = byCatalog.get(price.catalog) ?? [];
    current.push(price);
    byCatalog.set(price.catalog, current);
  }
  const duplicates: EatonDuplicateRow[] = [];
  for (const [catalog, rows] of byCatalog) {
    const spaIds = [
      ...new Set(rows.map((row) => row.spaId).filter((id) => id !== '')),
    ].sort();
    const pricesSeen = [
      ...new Set(
        rows.map((row) => normalizePrice(row.netPrice)).filter(Boolean),
      ),
    ].sort();
    if (spaIds.length < 2 && pricesSeen.length < 2) continue;
    duplicates.push({
      catalog,
      spaIds,
      prices: pricesSeen,
    });
  }
  return duplicates.sort((left, right) =>
    left.catalog.localeCompare(right.catalog),
  );
}
